import { ApolloClient } from '@apollo/client/core'
import getRecording from '@/graphql/recording/getRecording.gql'
import type { ApolloContext } from '@/services/types/Gql'
import type { Maybe } from '@/types/generated'
import type { Recording } from '@/services/types/Recording'

interface IRecordingGql {
  $apollo: ApolloClient<any>
  getRecording: (id: string, tenantId: string) => Promise<Maybe<Recording>>
}

export default class RecordingGql implements IRecordingGql {
  $apollo: ApolloClient<any>

  constructor (context: ApolloContext) {
    this.$apollo = context.$apollo
  }

  getRecording (id: string, tenantId: string): Promise<Maybe<Recording>> {
    return this.$apollo.query({
      query: getRecording,
      fetchPolicy: 'no-cache',
      variables: {
        id,
        tenantId
      }
    }).then(result => result.data?.recording)
  }
}
